import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Check } from 'lucide-react';
import { chapters, canAccessChapter } from '../data/chapters';

const TableOfContents = ({ currentChapter, userTier, onClose }) => {
  return (
    <div className="bg-white border-r border-gray-200 h-full overflow-y-auto">
      <div className="p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Table of Contents</h3>
        
        <div className="space-y-1">
          {Object.values(chapters).map((chapter) => {
            const hasAccess = canAccessChapter(chapter.id, userTier);
            const isCurrent = currentChapter === chapter.id;
            
            return (
              <Link
                key={chapter.id}
                to={`/ebook/${chapter.slug}`}
                onClick={onClose}
                className={`block px-4 py-2 rounded-lg transition-colors ${
                  isCurrent
                    ? 'bg-amber-100 text-amber-900 font-semibold'
                    : hasAccess
                    ? 'hover:bg-gray-100 text-gray-700'
                    : 'text-gray-400 cursor-not-allowed'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="text-sm">{chapter.title}</div>
                    {chapter.subtitle && (
                      <div className="text-xs opacity-75">{chapter.subtitle}</div>
                    )}
                  </div>
                  {isCurrent && (
                    <Check className="h-4 w-4 ml-2 flex-shrink-0" />
                  )}
                  {!hasAccess && (
                    <Lock className="h-4 w-4 ml-2 flex-shrink-0" />
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TableOfContents;